// src/pages/HousingSupport.tsx
import React from 'react';
import CategoryPage from './CategoryPage';

const HousingSupport: React.FC = () => <CategoryPage categoryId="housing" art="house" />;

export default HousingSupport;
